import { render } from "./gallery.vue?vue&type=template&id=18c0ae6a&ts=true"
import script from "./gallery.vue?vue&type=script&lang=ts"
export * from "./gallery.vue?vue&type=script&lang=ts"

import exportComponent from "C:\\projects\\Auraclub\\app\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__